import List from "./list/list.module";

export default {
  modules: {
    List,
  },
};
